module.exports = __webpack_public_path__ + "img/kesehatan.cff00baf.jpg";